import { Checkbox, FormControlLabel } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface CheckboxFieldProps {
  label: string;
  name: string;
  lablePosition?: any;
  disabled?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

export const FormCheckbox = ({ name, label, lablePosition, disabled, onChange: onChangeProp }: CheckboxFieldProps): any => {
  const { control } = useFormContext();

  return (
    <div>
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, onBlur, value } }) => {
          const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
            onChange(event); // React Hook Form's onChange
            if (onChangeProp) {
              onChangeProp(event, checked); // Parent component's onChange
            }
          };

          return (
            <FormControlLabel
              control={<Checkbox onChange={handleChange} onBlur={onBlur} checked={value} disabled={disabled} />}
              label={label}
              name={name}
              labelPlacement={lablePosition ?? 'end'}
            />
          );
        }}
      />
    </div>
  );
};
